import {legacy_createStore, applyMiddleware} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers'; // your combined reducers file
import {reducersState} from './reducers'; // for typing RootState if TS

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['availability', 'student'],
  throttle: 1000,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Build middleware array
const middleware = [thunk];

// Create the store, wrapped with DevTools
const store = legacy_createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);

// Create the persistor to control rehydration
const persistor = persistStore(store);

export type RootState = reducersState;

export {store, persistor};
